import { CTAProps } from './types';
import Button from 'components/shared/Buttons/BaseButton';
import { Cta } from 'libs/contentful/types';

const CTA = ({ cta, ctaLevel, variant, className, id, testId }: CTAProps) => {
  // Use manual variant override if set, otherwise use the configured CTA variant
  const buttonVariant = variant || cta?.variant;

  return (
    <Button
      sys={cta?.sys}
      href={cta?.url}
      internalPage={cta?.internalPage}
      target={cta?.target}
      ctaLevel={ctaLevel}
      variant={buttonVariant}
      className={className}
      id={id}
      testId={testId}>
      {cta?.text}
    </Button>
  );
};

// Use this to check if a CTA is valid before trying to render it in a parent component
export const isValidCta = (cta?: Cta): boolean => {
  return Boolean((cta?.url || cta?.internalPage) && cta?.text);
};

export default CTA;
